module.exports = __webpack_public_path__ + "images/sprites/ui/assessment_steps_2f29b62ac38506fb3d5154542b6e2a41.png";